<template>
  <div style="position: relative">
    <i
      v-if="isDev && nodeId"
      class="el-icon-edit edit-btn"
      @click="dev"
    />

    <div
      :id="node"
      class="amis-tpl"
    />
  </div>
</template>
<script>
import {
  PUSH_AMIS_EDITOR,
  POP_AMIS_EDITOR,
  UPDATE_AMIS_EDITOR,
} from '@/store/mutation-types';
import { mapState, mapGetters } from 'vuex';
import Api from '@/core/Apis/ApiInfo';
import QuRequest from '@/core/QuRequest';

const ENV = CODE_EVN;
const Q = new QuRequest();
const isDev = ENV === 'development';
const AMIS = window.amisRequire('amis/embed');

export default {
  data() {
    return {
      isDev,
      node: '',
      nodeId: '',
    };
  },

  computed: {
    ...mapState(['amisEditor']),
    ...mapGetters(['checkPerm']),
  },

  watch: {
    'amisEditor.json': {
      deep: true,
      handler: 'onJsonChange',
    },
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      const { _path } = this.$route.query;
      this.node = _path;
      if (!this.node) return;

      const schema = await this.amisSchema();
      AMIS.embed(`#${this.node}`, schema, this.amisProps(), this.amisEnv());
    },

    async request({ url, method, data }) {
      try {
        const api = new Api({
          path: url,
          type: method,
          author: '徐从斌',
        });
        const res = await Q.send(api, data || {});
        const payload = {
          status: 0,
          msg: res.message || '',
          data: res.data,
        };

        return {
          ...res,
          data: payload,
        };
      } catch (err) {
        this.$message.error(`${err.message || '错误'}`);
      }
    },

    async amisSchema() {
      try {
        const res = await Q.send(Q.Apis.sales.amis.getPage, {
          path: this.node,
        });
        let page = JSON.parse((res.data || {}).config || '{}');
        this.nodeId = (res.data || {}).id || '';
        this.$store.commit(UPDATE_AMIS_EDITOR, page);
        return page;
      } catch (e) {
        this.$message.warning('页面加载失败，请检查json是否配置准确');
        return {};
      }
    },

    amisProps() {
      return {
        data: {
          env: ENV,
          checkPerm: this.checkPerm,
        },
      };
    },

    amisEnv() {
      return {
        fetcher: async ({ url, method, data }) => {
          let res = await this.request({ url, method, data });
          return res;
        },

        notify: (type, message) => {
          this.$message({ type, message });
        },

        affixOffsetTop: 80,
      };
    },

    dev() {
      if (!this.amisEditor.visible) {
        this.$store.commit(POP_AMIS_EDITOR, {
          id: this.nodeId || '',
          path: this.node || '',
        });
      } else {
        this.$store.commit(PUSH_AMIS_EDITOR);
      }
    },

    onJsonChange(v = {}) {
      AMIS.embed(`#${this.node}`, v, this.amisProps(), this.amisEnv());
    },
  },
};
</script>
<style lang="less" scoped>
.amis-tpl {
  // 默认底层透明背景，你可以在具体json中修改需要的背景色，而不是修改这个；
  background: transparent !important;
}
.edit-btn {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -27px;
  font-size: 18px;
  color: #000000;
  cursor: pointer;

  &:hover {
    color: #d81515;
  }
}
</style>